export default __webpack_public_path__ + "static/media/donate-06.3d502c66.png";